export const tileList = ["default", "OSM", "Aerial"]; //, "Aerial", "AerialLabel"

export const providerTile = {
  offline: "./offline/panama.pbf",
  OSM: {
    url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
    provider: "OSM",
  },
  Aerial: {
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    provider: "Esri",
  },
  // Aerial: { type: "Aerial", provider: "Bing" },
  // AerialLabel: { type: "AerialWithLabelsOnDemand", provider: "Bing" },
  // Road: { type: "RoadOnDemand", provider: "Bing" },
  /*cyclOSM: "https://dev.{a-c}.tile.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png",
  Roadmap: "http://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}",
  Terrain: "http://mt0.google.com/vt/lyrs=p&hl=en&x={x}&y={y}&z={z}",
  Altered_roadmap: "http://mt0.google.com/vt/lyrs=r&hl=en&x={x}&y={y}&z={z}",
  Satellite_only: "http://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}",
  Terrain_only: "http://mt0.google.com/vt/lyrs=t&hl=en&x={x}&y={y}&z={z}",
  Hybrid: "http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}",*/
};
